import React, {useState} from 'react';
import CIcon from '@coreui/icons-react';

import {CLink, CCardHeader, CCol, CRow, CCard, CCardBody, CCollapse} from '@coreui/react';

const CollapseCard = (props: any) => {
  const {headerClass, titleBoxClass, titleStrClass, titleStr, graphicClass, handleErrors, errorStates} = props;
  //console.log('Input group row props are: ', props)
  const [expanded, setExpanded] = useState(false);
  const handleExpansion = () => {
    setExpanded(!expanded);
  };
  handleErrors(errorStates);
  return (
    <CRow className="mb-3">
      <CCard style={{width: '100%'}}>
        <CCardHeader style={{cursor: 'pointer'}} onClick={handleExpansion} className={headerClass}>
          <CRow>
            <CCol xs="6">
              <CCol xs="4" className={titleBoxClass}>
                <span className={titleStrClass}> {titleStr}</span>
              </CCol>
            </CCol>
            <CCol xs="6" className="text-end">
              <CRow className="justify-content-end mr-1">
                <CLink className={graphicClass}>
                  <CIcon name={expanded ? 'cil-chevron-top' : 'cil-chevron-bottom'} />
                </CLink>
              </CRow>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCollapse show={expanded}>
          <CCardBody className="mb-3">{props.children}</CCardBody>
        </CCollapse>
      </CCard>
    </CRow>
  );
};
export default CollapseCard;
